import React from "react";
//import ReactDOM from "react-dom";
import { createRoot } from 'react-dom/client';
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./state/store";
import AuthStytchProvider from "./components/auth/AuthStytchProvider";
const container = document.getElementById('root');
const root = createRoot(container as HTMLElement)
root.render(
  <React.StrictMode>
    <AuthStytchProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </AuthStytchProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
